import { useSegments } from "sdk/command-palette/queries"

export const PAGE_ID = "segment-search"

export const SHORTCUT = "f g"

const SEARCH_ENTRY_COMMAND = {
  id: "search-segments",
  label: "Search Segments…",
  icon: "search",
  group: "Search",
  keywords: ["find", "segment", "list"],
  shortcut: SHORTCUT,
  onSelect: api => api.pushPage(PAGE_ID)
}

/**
 * Provider for segment search. At the root it offers the "Search segments…"
 * entry that opens the subpage. Like tag search, the whole segment list is
 * small and changes rarely, so we preload it once when the subpage opens and
 * let cmdk filter it client-side (the subpage sets `shouldFilter: true`).
 * Selecting a segment navigates to the subscribers list filtered by it.
 *
 * @type {import("../types").Provider}
 */
export function useSegmentSearchProvider({ activePageId }) {
  const active = activePageId === PAGE_ID

  const { data, isFetching } = useSegments({ enabled: active })

  if (!activePageId) {
    return { commands: [SEARCH_ENTRY_COMMAND], isLoading: false }
  }

  if (!active) return { commands: [], isLoading: false }

  const commands = (data?.segments ?? []).map(segment => {
    const path = `/subscribers?subscribable_type=List&subscribable_ids=${segment.id}`
    return {
      id: `segment-${segment.id}`,
      label: segment.name,
      icon: "segment",
      group: "Segments",
      href: path,
      onSelect: api => api.navigate(path)
    }
  })

  return { commands, isLoading: isFetching }
}

/**
 * @returns {import("../types").Shortcut[]}
 */
export function getSegmentSearchShortcuts() {
  return [{ shortcut: SHORTCUT, onTrigger: api => api.pushPage(PAGE_ID) }]
}
